import {Component, Input, OnInit} from '@angular/core';
import {DocumentsService} from "@app/features/workCompDashboard/services/documents.service";
import {ActivatedRoute} from "@angular/router";
import {Observable, of, take} from "rxjs";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {map} from "rxjs/operators";

@Component({
  selector: 'app-document-pdf-viewer',
  standalone: false,
  templateUrl: './document-pdf-viewer.component.html',
  styleUrl: './document-pdf-viewer.component.scss'
})
export class DocumentPdfViewerComponent implements OnInit {
  private documentId?: string;
  private personId?: string;
  pdfUrl$?: Observable<SafeResourceUrl>;

  constructor(
    private documentsService: DocumentsService,
    private activatedRoute: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) {  }

  ngOnInit(): void {
    this.parseRouteParams();
    this.showDocument();
  }

  private parseRouteParams(): void {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.personId = params.get('personId') ?? undefined;
      this.documentId = params.get('documentId') ?? undefined;
    });
  }

  private showDocument(): void {
    if (this.documentId && this.personId) {
      this.pdfUrl$ = this.documentsService.getDocumentBlob$(this.personId, this.documentId)
        .pipe(
          take(1),
          map((result) => {
            const url = URL.createObjectURL(result);
            return this.sanitizer.bypassSecurityTrustResourceUrl(url);
          })
        );
    }
  }
}
